// Live data for the Systems pages: Now's useLive (polled, resting while the tab is hidden), with a range that is asked
// again at once when it changes while the picture stays until the answer comes (another thing — tenant, environment,
// system — starts clean).
import { useEffect, useRef } from 'react';
import { useLive, type Live } from '../now/useLive.ts';

export function useRangeLive<T, R>(load: (range: R) => Promise<T>, range: R, intervalMs: number, deps: unknown[]): Live<T & { range: R }> {
  const rangeRef = useRef(range);
  rangeRef.current = range;
  const live = useLive(() => {
    const r = rangeRef.current;
    return load(r).then((v) => ({ ...v, range: r }));
  }, intervalMs, deps);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    live.reload();
  }, [range]); // eslint-disable-line react-hooks/exhaustive-deps
  return live;
}
